import { webLocalStorageAdapter, initializeSupabaseClient, type Database } from '@tickethall/core';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const supabase = initializeSupabaseClient({
  url: SUPABASE_URL,
  publishableKey: SUPABASE_PUBLISHABLE_KEY,
  storage: webLocalStorageAdapter,
  persistSession: true,
  autoRefreshToken: true,
});

export type { Database };
